import key from 'weak-key';

// types
import type { AwardsProps } from './awards.types';

// components
import { AwardBlock } from './award-block';
import { Title } from '../Title/Title';
import { InlineEdit } from 'components/ContentCreator/InlineEdit';
import { TitleFormats } from '../Title/title.types';

// utils
import { useSectionId } from 'utils/hooks/use-section-id';
import { isEmpty } from 'utils/is-empty';
import { decodingContent } from 'utils/decodingContent';

export function Awards({
  blocks,
  subtitle,
  title,
  anchor,
  contentIndex,
  titleInAnchor,
  text: copyText,
}: Readonly<AwardsProps>) {
  const sectionId = useSectionId(title, anchor ?? '', titleInAnchor, contentIndex);

  return (
    <div className="grid-container">
      <div className="c-award" id={sectionId}>
        <Title
          title={decodingContent(title)}
          subtitle={decodingContent(subtitle)}
          Format={TitleFormats.h2}
          titlePreviewId="#st_titleText"
          subtitlePreviewId="#st_subtitle"
          formatClassName="h3"
        />
        {!isEmpty(copyText) && (
          <div className="c-award__text">
            <InlineEdit previewId="#st_text">{copyText}</InlineEdit>
          </div>
        )}
        {!isEmpty(blocks) && (
          <div className="c-award__columns">
            {blocks.map((block, index) => {
              const blocks = block.awards.length > 0 && (
                <div className="awards">
                  <div
                    key={key(block)}
                    className="c-award__column cell large-6 grid-x"
                    data-preview-id={index === 0 ? '#st_awards' : '#st_awards2'}
                  >
                    <AwardBlock awards={block.awards} />
                  </div>
                </div>
              );

              const title = decodingContent(block.title);
              return (
                <div
                  key={`${key(block)}-title`}
                  className="c-award__column c-award__column-headline"
                >
                  {title && (
                    <h3 className="small-12 h4">
                      <InlineEdit previewId={index === 0 ? '#st_title' : '#st_title2'}>
                        {title}
                      </InlineEdit>
                    </h3>
                  )}
                  {blocks}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
